/**
 * Varianten-Auswahl auf der Produktkarte (Design-Handoff Produktkarte, Stufe 1).
 * Chip-/Swatch-Wechsel aktualisiert Preis, Streichpreis, Grundpreis, Lagerhinweis,
 * Warenkorb-Button (Varianten-ID) und Kartenbild — ohne Fetch, Daten liegen als JSON an der Karte.
 */
(function () {
  'use strict';

  function parseData(pcv) {
    var script = pcv.querySelector('.pcv-data');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function variantsForValue(data, value) {
    return data.variants.filter(function (v) {
      return v.options[data.axis] === value;
    });
  }

  function pickVariant(data, value) {
    var candidates = variantsForValue(data, value);
    if (!candidates.length) return null;
    var available = candidates.filter(function (v) { return v.available; });
    var pool = available.length ? available : candidates;
    // choose-Modi: günstigste lieferbare Variante des Werts als Preisreferenz
    return pool.reduce(function (min, v) { return v.priceCents < min.priceCents ? v : min; }, pool[0]);
  }

  function multiplePrices(list) {
    if (list.length < 2) return false;
    var first = list[0].priceCents;
    return list.some(function (v) { return v.priceCents !== first; });
  }

  function updateCard(card, pcv, data, value) {
    var variant = pickVariant(data, value);
    if (!variant) return;
    var isChoose = data.mode === 'chips-choose' || data.mode === 'swatches-choose';
    var candidates = variantsForValue(data, value);
    var showFrom = isChoose && multiplePrices(candidates);

    // Preiszeile
    var price = card.querySelector('.price');
    if (price) {
      var ins = price.querySelector('ins .amount');
      if (ins) ins.textContent = (showFrom ? 'ab ' : '') + variant.price;
      var del = price.querySelector('del');
      if (variant.compare && !showFrom) {
        if (!del) {
          del = document.createElement('del');
          del.innerHTML = '<span class="amount discounted"></span>';
          price.insertBefore(del, price.firstChild);
        }
        del.classList.remove('hidden');
        del.querySelector('.amount').textContent = variant.compare;
      } else if (del) {
        del.classList.add('hidden');
      }
      var unit = price.querySelector('.unit-price');
      if (unit) {
        if (variant.unit) {
          unit.classList.remove('hidden');
          var spans = unit.querySelectorAll('span');
          // Grundpreis als eigene Zeile, Format "8,00 € / kg"
          unit.textContent = (showFrom ? 'ab ' : '') + variant.unit;
        } else {
          unit.classList.add('hidden');
        }
      }
    }

    // Lagerhinweis
    var stock = card.querySelector('.pcv-stock');
    if (stock) {
      if (!variant.available) {
        stock.classList.add('hidden');
      } else {
        stock.classList.remove('hidden');
        var low = variant.qty !== null && variant.qty > 0 && variant.qty < 5 && variant.policy !== 'continue';
        stock.classList.toggle('pcv-stock--low', low);
        stock.textContent = low ? '● Nur noch ' + variant.qty + ' auf Lager' : '● Auf Lager';
      }
    }

    // Button (nur chips-add: Varianten-ID + Zustand)
    var button = card.querySelector('.product-card--add-to-cart-button');
    if (button) {
      button.dataset.productId = variant.id;
      if (!isChoose) {
        var label = button.querySelector('.product-card--add-to-cart-text');
        if (variant.available) {
          button.removeAttribute('aria-disabled');
          if (label) label.textContent = (window.theme && theme.variantStrings && theme.variantStrings.addToCart) || 'In den Warenkorb';
        } else {
          button.setAttribute('aria-disabled', 'true');
          if (label) label.textContent = (window.theme && theme.variantStrings && theme.variantStrings.soldOut) || 'Ausverkauft';
        }
      }
    }

    // Kartenbild
    if (variant.img) {
      var img = card.querySelector('.product-primary-image');
      if (img && img.tagName === 'IMG') {
        img.removeAttribute('srcset');
        img.src = variant.img;
      }
    }

    // Bild-/Titel-Links auf die Variante zeigen lassen
    card.querySelectorAll('.product-card-image-link, .product-card-title').forEach(function (a) {
      a.setAttribute('href', variant.url);
    });

    // Farbname im Mono-Label
    var labelValue = pcv.querySelector('.pcv-label-value');
    if (labelValue) labelValue.textContent = '· ' + value;

    // Aktuelle Auswahl für das Varianten-Overlay merken
    pcv.dataset.currentId = variant.id;
  }

  // aria-disabled bleibt fokussierbar, darf aber nicht ausloesen (Auftrag Button-Farbsystem §3)
  document.addEventListener('click', function (e) {
    var blocked = e.target.closest('[aria-disabled="true"]');
    if (blocked && blocked.closest('product-card, .plv-list, .vm')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (e) {
    // Auswahl auf der Karte
    var option = e.target.closest('.pcv-chip, .pcv-swatch');
    if (!option || option.getAttribute('aria-disabled') === 'true') return;
    var pcv = option.closest('.pcv');
    var card = option.closest('product-card');
    if (!pcv || !card) return;
    var data = parseData(pcv);
    if (!data) return;

    pcv.querySelectorAll('.pcv-chip, .pcv-swatch').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-checked', 'false');
    });
    option.classList.add('is-active');
    option.setAttribute('aria-checked', 'true');

    updateCard(card, pcv, data, option.dataset.pcvValue);
  });

  // Initial: Preis/Lager auf die Vorauswahl synchronisieren (SSR zeigt den Produkt-Minimalpreis)
  function init() {
    document.querySelectorAll('product-card .pcv').forEach(function (pcv) {
      var card = pcv.closest('product-card');
      var active = pcv.querySelector('.pcv-chip.is-active, .pcv-swatch.is-active');
      var data = parseData(pcv);
      if (card && active && data) updateCard(card, pcv, data, active.dataset.pcvValue);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
